/**
 * Format an ISO timestamp in a specific timezone for display.
 * If no timezone provided, defaults to UTC.
 */
export function formatInStationTimezone(
  isoTimestamp: string | null | undefined,
  stationTimezone?: string | null,
  options?: Intl.DateTimeFormatOptions
): string {
  if (!isoTimestamp) return '—';
  try {
    const date = new Date(isoTimestamp);
    if (isNaN(date.getTime())) return '—';
    const tz = stationTimezone || 'UTC';
    return date.toLocaleString('en-GB', { timeZone: tz, ...options });
  } catch {
    // Invalid timezone — fall back to UTC
    return new Date(isoTimestamp).toLocaleString('en-GB', { timeZone: 'UTC', ...options });
  }
}

/**
 * Get the short timezone abbreviation (e.g., "EET", "UTC", "CET") for a given timezone.
 */
export function getTimezoneAbbreviation(stationTimezone?: string | null): string {
  if (!stationTimezone) return 'UTC';
  try {
    const parts = new Intl.DateTimeFormat('en-GB', {
      timeZone: stationTimezone,
      timeZoneName: 'short',
    }).formatToParts(new Date());
    return parts.find(p => p.type === 'timeZoneName')?.value || stationTimezone;
  } catch {
    return 'UTC';
  }
}
